var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplay)?_c('footer',{class:_vm.isSP ? 'footer--sp' : 'footer--pc'},[_vm._v(" ©2019 nukumo ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }